import React from 'react';
import CRUDTableQuery from "../CRUDTableQuery";
import CRUDTableStandart from "../CRUDTableStandart";
import { formatDate } from "../../../functions/formatters";
import { checkRoles } from "../../../functions/checkRoles";
import { $authHost } from "../../../http";

// ✅ собственный метод получения заявок
const clientHistoryCRUD = {
    getRequests: async ({ paging, filter, sort }) => {
        const { data } = await $authHost.post('/api/v1/area/client/request', {
            paging,
            filter,
            sort
        });
        return data;
    }
};
//
export default function ClientHistoryCRUDTable({ type = 'standart', ...props }) {
    const isSuperAdmin = checkRoles("SuperAdministrator");

    const columns = [
        { title: "#", dataIndex: "id", key: "id" },
        {
            title: "Номер заявки",
            key: "number",
            render: (_, row) =>
                row.number ? (
                    row.number
                ) : (
                    <span style={{ color: "gray" }}>Не задан</span>
                ),
        },
        {
            title: "Дата создания",
            key: "createdAt",
            render: (_, row) =>
                row.createdAt ? (
                    formatDate(row.createdAt)
                ) : (
                    <span style={{ color: "gray" }}>Не указана</span>
                ),
        },
        {
            title: "Сумма",
            key: "specificationsSummary",
            render: (_, row) =>
                row.specificationsSummary ? (
                    `${row.specificationsSummary} ₸`
                ) : (
                    <span style={{ color: "gray" }}>0 ₸</span>
                ),
        },
        {
            title: "Статус",
            key: "state",
            render: (_, row) =>
                row.state?.name ? (
                    row.state.name
                ) : (
                    <span style={{ color: "gray" }}>Не задан</span>
                ),
        },
        {
            title: "Количество услуг",
            key: "specifications",
            render: (_, row) =>
                row.specifications?.length ? (
                    row.specifications.length
                ) : (
                    <span style={{ color: "gray" }}>0</span>
                ),
        },
    ];

    const searchFields = [
        {
            title: "#",
            key: "id",
            compareType: "equals",
            operandPosition: 1,
            filterType: "normal",
        },
        {
            title: "Номер заявки",
            key: "number",
            compareType: "like",
            operandPosition: 1,
            filterType: "normal",
        },
    ];

    const filterFields = [
        {
            title: "Статус заявки",
            key: "stateId",
            compareType: "equals",
            operandPosition: 1,
            type: "normal",
            filterType: "normal",
            optionLabelKey: "name",
        },
        {
            title: "Дата создания с",
            key: "createdAt",
            operandPosition: 1,
            compareType: "between",
            type: "date2",
            filterType: "normal",
        },
        {
            title: "Дата создания по",
            key: "createdAt",
            operandPosition: 2,
            compareType: "between",
            type: "date2",
            filterType: "normal",
        },
    ];

    const CRUDTables = {
        standart: CRUDTableStandart,
        query: CRUDTableQuery,
    };

    const CRUDTable = CRUDTables[type];

    return (
        <CRUDTable
            search={clientHistoryCRUD.getRequests}
            columns={columns}
            {...props}
            filterFields={filterFields}
            searchFields={searchFields}
            extraFilter={{
                ...(!isSuperAdmin && {
                    typeId: {
                        operand1: 5,
                        operator: "notEquals",
                    },
                }),
            }}
        />
    );
}
